"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PostProductSizeDelete = void 0;
const Base_1 = require("./Base");
exports.PostProductSizeDelete = {
    url: Base_1.URL_BASE + "/ProductSizeDelete",
    method: "POST",
    secure: true
};
//# sourceMappingURL=PostProductSizeDelete.js.map